module.exports = __webpack_public_path__ + "img/icon_outline.8638baa0.png";